import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import PermissionChecker from '~/components/permission_checker';
import { useWebsocket } from '~/providers/websocket';
import { fetchComparisonPdfs, getComparisonDocumentsById, } from '~/redux/reducers/states/comparison_documents';
import Permissions from '~/settings/permissions';
import DocumentsPanel from './documents_panel';
import LeftPanel from './left_panel';
const FileViewComparison = () => {
    const { areComparisonDocumentsLoading, isFetchingComparisonDocPdfs, comparisonDocuments, documentComparisonId: reduxDocumentComparisonId, } = useSelector((state) => state.comparisonDocumentsState);
    const dispatch = useDispatch();
    const { id: documentComparisonId } = useParams();
    const [anchorDoc, setAnchorDoc] = useState();
    const [anchorHasRendered, setAnchorHasRendered] = useState(false);
    const [comparatorDoc, setComparatorDoc] = useState();
    const [comparatorHasRendered, setComparatorHasRendered] = useState(false);
    const [activeClauseIds, setActiveClauseIds] = useState({});
    const [selectedClauseName, setSelectedClauseName] = useState();
    const accordionRef = useRef(null);
    const ws = useWebsocket();
    const switchAnchorDoc = (documentComparisonFileId) => {
        var _a;
        (_a = accordionRef.current) === null || _a === void 0 ? void 0 : _a.click();
        setAnchorDoc(comparisonDocuments.find((cd) => {
            return cd.documentComparisonFileId === documentComparisonFileId;
        }));
    };
    const switchComparatorDoc = (documentComparisonFileId) => {
        var _a;
        (_a = accordionRef.current) === null || _a === void 0 ? void 0 : _a.click();
        setComparatorDoc(comparisonDocuments.find((cd) => {
            return cd.documentComparisonFileId === documentComparisonFileId;
        }));
    };
    const swapDocs = () => {
        var _a;
        (_a = accordionRef.current) === null || _a === void 0 ? void 0 : _a.click();
        setAnchorDoc(comparatorDoc);
        setComparatorDoc(anchorDoc);
    };
    const documentsPanelState = {
        accordionRef,
        activeClauseIds,
        anchorDoc,
        anchorHasRendered,
        areComparisonDocumentsLoading,
        comparatorDoc,
        comparatorHasRendered,
        comparisonDocuments,
        setAnchorHasRendered,
        setComparatorHasRendered,
        selectedClauseName,
        swapDocs,
        switchAnchorDoc,
        switchComparatorDoc,
    };
    const leftPanelState = {
        accordionRef,
        activeClauseIds,
        anchorDoc,
        anchorHasRendered,
        comparatorDoc,
        comparatorHasRendered,
        comparisonDocuments,
        selectedClauseName,
        setActiveClauseIds,
        setSelectedClauseName,
    };
    useEffect(() => {
        if (reduxDocumentComparisonId !== documentComparisonId) {
            dispatch(getComparisonDocumentsById({ documentComparisonId, ws }));
        }
    }, [documentComparisonId]);
    useEffect(() => {
        if (comparisonDocuments.length === 0 || isFetchingComparisonDocPdfs)
            return;
        if (!comparisonDocuments.every((doc) => doc.blob)) {
            dispatch(fetchComparisonPdfs({ comparisonDocuments }));
            return;
        }
        if (!anchorDoc) {
            setAnchorDoc(comparisonDocuments[0]);
        }
        if (!comparatorDoc) {
            setComparatorDoc(comparisonDocuments[1]);
        }
    }, [comparisonDocuments]);
    if (isFetchingComparisonDocPdfs || areComparisonDocumentsLoading) {
        return React.createElement(LoadingElement, { large: true, isLightBackground: true });
    }
    return React.createElement(PermissionChecker, { isRoute: true, requiredAllPermissions: [Permissions.BROWSE_MULTI_DOCS] },
        React.createElement("div", { className: 'document-compare-view page-content-wrapper' },
            React.createElement(LeftPanel, { state: leftPanelState }),
            React.createElement(DocumentsPanel, { state: documentsPanelState })));
};
export default FileViewComparison;
